// extracted by mini-css-extract-plugin
export var backgroundShapes = "fl_lK";
export var container = "fl_f";
export var imageBox = "fl_kj";
export var textContainer = "fl_cQ";